import { useEffect, useLayoutEffect } from 'react';
import { isBrowser } from '../util/const.js';
export const useIsomorphicLayoutEffect = isBrowser ? useLayoutEffect : useEffect;
